export default __webpack_public_path__ + "static/media/dashboardHeader.b7198903.png";